<div class="mct-flex mct-col mct-gap-20"  >
  <div class="relationshipHeader" [hidden]="!profileRelation.ParentReportName">
    <wl-profile-type-icon [profileId]="profileRelation.ProfileID"></wl-profile-type-icon>&nbsp;
    <label>
      <strong> {{ profileRelation.ParentReportName }}</strong>
      ({{ profileRelation.ProfileID }})
    </label>
  </div>
  <div>
    <p-checkbox
      [disabled]="relatedProfileAccess < 2"
      [binary]="true"
      inputId="mainContact"
      [(ngModel)]="profileRelation.MainContact"
    ></p-checkbox>
    <label for="mainContact">
      {{ 'profiles.edit.relationship.main-contact-of' | translate | titlecase }}
      <strong>{{ profileRelation.ParentReportName }}</strong>
    </label>
  </div>
  <div>
    <p-checkbox
      [disabled]="relatedProfileAccess < 2"
      [binary]="true"
      inputId="isEditor"
      [(ngModel)]="profileRelation.IsEditor"
    ></p-checkbox>
    {{ 'profiles.edit.relationship.editor-of' | translate | titlecase }}
    <label for="isEditor">
      <strong>{{ profileRelation.ParentReportName }}</strong>
    </label>
  </div>
  <div>
    <p-checkbox
      [disabled]="relatedProfileAccess < 2"
      [binary]="true"
      inputId="receivesCommunication"
      [(ngModel)]="profileRelation.ReceivesCommunication"
    ></p-checkbox>
    <label for="receivesCommunication">
      {{ 'profiles.edit.relationship.receives-communication' | translate | titlecase }}
    </label>
  </div>
  <div>
    <p-checkbox
      [disabled]="relatedProfileAccess < 2"
      [binary]="true"
      inputId="billingContact"
      [(ngModel)]="profileRelation.BillingContact"
    ></p-checkbox>
    <label for="billingContact">
      {{ 'profiles.edit.relationship.billing-contact' | translate | titlecase }}
    </label>
  </div>
  <div>
    <p-checkbox
      [disabled]="relatedProfileAccess < 2"
      data-cy="checkboxEditProfileInheritContactInfo"
      inputId="updateAddress"
      [binary]="true"
      [(ngModel)]="profileRelation.InheritContactInfo"
    ></p-checkbox>
    <label for="updateAddress">
      {{ 'profiles.edit.relationship.update' | translate | titlecase }}
      <span style="font-weight: bold" [hidden]="!profileRelation.ReportName"
        >{{ profileRelation.ReportName ? profileRelation.ReportName : '' }}'s</span
      >
      {{ 'profiles.edit.relationship.inherit-contact-info-text' | translate }}
      <span style="font-weight: bold">{{ profileRelation.ParentReportName }}</span>
    </label>
  </div>
  <div>
    <div>
      <label>{{ 'profiles.edit.relationship.relationship-type' | translate | titlecase }}</label>
    </div>
    <p-select
      (onChange)="relationTypeChanged()"
      [disabled]="relatedProfileAccess < 2"
      [required]="true"
      data-cy="dropdownEditProfileRelationshipType"
      [options]="relationTypes"
      optionLabel="RelationType"
      dataKey="RelationTypeId"
      [(ngModel)]="selectedRelationType"
      appendTo="body"
    ></p-select>
  </div>
  <div>
    <label>{{ 'profiles.edit.relationship.relationship-title' | translate | titlecase }}</label>
    <input [disabled]="relatedProfileAccess < 2" [(ngModel)]="profileRelation.Title" type="text" class="form-control" />
  </div>
</div>
